import {seoResolver} from '@vuefront-seo-resolver'

export default async (app) => {
  app.$router.beforeEach(async (to, from, next) => {
    if (to.path !== from.path) {      
      if (app.$store.getters["vuefront/sidebarCart"]) {        
        app.$store.commit("vuefront/toggleSidebarCart");
      }      
      if (app.$store.getters["vuefront/flagForSidebarCart"]) {        
        app.$store.commit("vuefront/setSidebarCart", true, {root: true});
        app.$store.commit("vuefront/setFlagForSidebarCart", false, {root: true});
      }
    }

    // Returning the resolver promise is essential during SSR. If OpenCart is
    // unavailable, Vue Router must receive the rejection so entry-server can
    // turn it into a bounded HTTP 503. A detached promise here becomes an
    // unhandledRejection and can terminate the Node process.
    return seoResolver.call(app, app, to, from, next)
  })
  // app.$router.afterEach((to, from) => {        
  //   if (to.path !== from.path) {                  
  //     if (app.$store.getters["vuefront/flagForSidebarCart"]) {        
  //       app.$store.commit("vuefront/setSidebarCart", true, {root: true});
  //     }
  //   }
  // })
  let initialSeoNavigationPromise = null
  await seoResolver.call(app, app, app.$router.currentRoute, app.$router.currentRoute, (path) => {
    if (path) {
      initialSeoNavigationPromise = app.$router.push(path)
    }
  })
  if (initialSeoNavigationPromise) {
    await initialSeoNavigationPromise
  }
}
